module.exports = __webpack_public_path__ + "static/img/exchange.4088e94.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/exchange.png
// module id = QrX+
// module chunks = 1